import { FileUploadCtrl }      from './file-upload.ajs';
import { FileUploadDirective } from './file-upload.directive.ajs';
import { S3UploadService }     from './s3-upload.service.ajs';

angular.module('app-lite.core.file-upload', [])
.controller('FileUploadCtrl', FileUploadCtrl)
.directive('fileUpload', FileUploadDirective)
.factory('s3Upload', S3UploadService);
